import {FC} from 'react'

import {USER_CONTAINER_WIDTH} from '@/theme/sizing'
import {theme} from '@/theme/theme'

export const Container: FC<React.PropsWithChildren<unknown>> = ({children}) => (
  <>
    <div className="wrapper">{children}</div>

    <style jsx>{`
      .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: ${USER_CONTAINER_WIDTH};
        padding: ${theme.spacing[7]} ${theme.spacing[3]};
        margin: 0 auto;
        box-sizing: content-box;
      }
    `}</style>
  </>
)
